"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIsExistingToken = void 0;
var normalizeNotificationTokens_1 = require("../../functions/utilities/normalizeNotificationTokens");
var getIsExistingToken = function (_a) {
    var unscopeUser = _a.unscopeUser, findToken = _a.findToken;
    var notificationTokens = (0, normalizeNotificationTokens_1.normalizeNotificationTokens)({ unscopeUser: unscopeUser });
    var existingToken = findToken &&
        (notificationTokens === null || notificationTokens === void 0 ? void 0 : notificationTokens.find(function (notificationToken) {
            return notificationToken.token === findToken && notificationToken.appName;
        }));
    return !!existingToken;
};
exports.getIsExistingToken = getIsExistingToken;
